import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CmnFilters from "../../../components/lead-management/common/CmnFilters";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  currentMonthName,
  currentMonthNumber,
  currentYear,
  TODAYS_DATE_FORMATTED,
} from "../../../components/common-data/Converts";
import { fetchAgentDailyTargetata } from "../../../redux/prospect-reducers/prospectSlice";
import DashboardCard from "../common/DashboardCard";
import AgentWeeklyReport from "./AgentWeeklyReport";
import CommonStructured from "../../../components/common-components/CommonStructured";

const AgentwiseDailyTagrget = ({ userInfoData, prevAllFilters, rowData }) => {
  const dispatch = useDispatch();
  const {
    agentsDailyTargteLoading,
    agentsDailyTargte,
    agentsDailyTargteError,
  } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const iniDatas = {
    pagination: [],
    allData: [],
    allDataStats: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const iniAllFilter = {
    selectedGym:
      rowData?.gym_id && rowData?.gym_name
        ? { value: rowData.gym_id, label: rowData.gym_name }
        : prevAllFilters?.selectedGym
        ? prevAllFilters.selectedGym
        : !isAdmin && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.uid ||
              userInfoData?.user_id ||
              "",
          }
        : "",
    selectedMonth: {
      label: currentMonthName,
      value: currentMonthNumber,
    },
    selectedYear: {
      label: currentYear,
      value: currentYear,
    },
    selectedFd:
      !isAdmin && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selAddedby: prevAllFilters?.selAddedby || "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    gym_id: allFilters.selectedGym?.value || "",
    month: allFilters.selectedMonth?.value || "",
    year: allFilters.selectedYear?.value || "",
    staff_id: allFilters.selectedFd?.value || "",
    cluster_manager_id: allFilters.selAddedby?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const getCardLabel = (key) => {
    switch (key) {
      case "fd_acheived_target":
        return "FD acheived target";
      default:
        return key.replace(/_/g, " ");
    }
  };

  function getAgentDailyTargetData(filters) {
    const { page, limit, filter_type, ...rest } = filters;

    dispatch(
      fetchAgentDailyTargetata({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym:
  //       rowData?.gym_id && rowData?.gym_name
  //         ? { value: rowData.gym_id, label: rowData.gym_name }
  //         : prevAllFilters?.selectedGym
  //         ? prevAllFilters.selectedGym
  //         : !isAdmin
  //         ? {
  //             label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //             value:
  //               userInfoData?.gym_id ||
  //               userInfoData?.uid ||
  //               userInfoData?.user_id ||
  //               "",
  //           }
  //         : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    if (prevAllFilters?.selAddedby) {
      setAllFilters((prevs) => ({
        ...prevs,
        selAddedby: prevAllFilters.selAddedby,
      }));
    }
  }, [prevAllFilters?.selAddedby]);

  useEffect(() => {
    getAgentDailyTargetData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      month: allFilters.selectedMonth?.value || "",
      year: allFilters.selectedYear?.value || "",
      staff_id: allFilters.selectedFd?.value || "",
      cluster_manager_id: allFilters.selAddedby?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedMonth,
    allFilters.selectedYear,
    allFilters.selectedFd,
    allFilters.selAddedby,
  ]);

  useEffect(() => {
    if (
      agentsDailyTargte?.status &&
      agentsDailyTargte?.data &&
      !agentsDailyTargteLoading &&
      !agentsDailyTargteError
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: agentsDailyTargte.data,
        pagination:
          agentsDailyTargte?.pagination?.length > 0
            ? agentsDailyTargte.pagination
            : [],
        allDataStats: agentsDailyTargte?.stats ? agentsDailyTargte.stats : {},
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [agentsDailyTargte, agentsDailyTargteLoading, agentsDailyTargteError]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "uid",
      text: "agent Info",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 link"
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "FD_weekly_target",
                rowData: row,
              }))
            }
          >
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "target_value",
      text: "overall target",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.target_value || 0)}
          </span>
        );
      },
    },
    {
      dataField: "today_target",
      text: `Today's (${TODAYS_DATE_FORMATTED}) target`,
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.today_target || 0)}
          </span>
        );
      },
    },
    {
      dataField: "target_acheived",
      text: "target acheived",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.target_acheived || 0)}
            <br />(
            <small>{convertThenFormat(row?.total_acheive_per || 0)} %</small>)
          </span>
        );
      },
    },
    {
      dataField: "target_remaining",
      text: "target remaining",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.target_remaining || 0)}
          </span>
        );
      },
    },
    {
      dataField: "ideal_target_total",
      text: "total ideal target",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.ideal_target_total || 0)}
          </span>
        );
      },
    },
    {
      dataField: "ideal_target_as_today_total",
      text: `Ideal target as Today (${TODAYS_DATE_FORMATTED})`,
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.ideal_target_as_today_total || 0)}
          </span>
        );
      },
    },
    {
      dataField: "deficit_total",
      text: "total deficit",
      formatter: (cell, row) => {
        const totalDeficit = Number(row?.deficit_total || 0);
        const isAbove = totalDeficit <= 0 ? true : false;

        return (
          <span
            className="tb-data minWidth100"
            style={{
              color: isAbove ? "#209216" : "#E41815",
            }}
          >
            ₹{convertThenFormat(row?.deficit_total || 0)}
            {isAbove ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-up-short"
                viewBox="0 0 16 16"
                style={{ color: "#209216" }}
              >
                <path
                  fillRule="evenodd"
                  d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-down-short"
                viewBox="0 0 16 16"
                style={{ color: "#E41815" }}
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                />
              </svg>
            )}
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.gym_name || "NA"}</span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <div className="modalHeadAndCloseContainer mod-with-details">
            <div className="user-info">
              <div className="user-details">
                <span className="mod-header">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                    onClick={onCloseModal}
                  >
                    <g id="navigate_before">
                      <path
                        id="icon"
                        d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                        fill="#1D1B20"
                      />
                    </g>
                  </svg>
                  {clickValues.rowData?.name || "NA"}
                </span>
                <span className="mod-regular-text underline">
                  +91 {clickValues.rowData?.mobile || ""}
                </span>
                <span className="mod-regular-text lowercase underline">
                  {clickValues.rowData?.email || ""}
                </span>
                <span className="mod-light-text">
                  {clickValues.rowData?.gym_name || ""}
                </span>
              </div>
            </div>

            <button
              type="button"
              className="closeModalBtn hideMobile"
              onClick={onCloseModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
              </svg>
            </button>
          </div>

          <AgentWeeklyReport
            userInfoData={userInfoData}
            prevAllFilters={allFilters}
            rowData={clickValues.rowData}
          />
        </div>
      </Modal>

      <CommonStructured
        pageHeading={"FD Targets"}
        isReload={() => {
          getAgentDailyTargetData(filters);
        }}
      />

      <CmnFilters
        from="agent-daily-target"
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        isLoading={agentsDailyTargteLoading}
      />

      {agentsDailyTargteLoading ? null : (
        <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
          {allDatas.allDataStats &&
            Object.entries(allDatas.allDataStats).map(([key, value], index) => {
              return (
                <React.Fragment key={index}>
                  {
                    <DashboardCard
                      tagName="fd-target"
                      filterType={key}
                      cardLabel={getCardLabel(key)}
                      value={`₹${convertThenFormat(value || 0)}`}
                    />
                  }
                </React.Fragment>
              );
            })}
        </div>
      )}

      {agentsDailyTargteLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            isFirstColSticky={true}
            isCustPagi={true}
          />
        </div>
      )}
    </>
  );
};

export default AgentwiseDailyTagrget;
